import Vue from 'vue'
import VueI18n from 'vue-i18n'

import pl from 'submodules/i18n/pl.json'
import en from 'submodules/i18n/en.json'
import de from 'submodules/i18n/de.json'
import es from 'submodules/i18n/es.json'
import ua from 'submodules/i18n/ua.json'
import mx from 'submodules/i18n/mx'
import ca from 'submodules/i18n/ca'

Vue.use(VueI18n)

const messages = {
    pl,
    en,
    de,
    es,
    ua,
    mx,
    ca
}

export default new VueI18n({
    locale: 'pl',
    fallbackLocale: ['en', 'pl'],
    messages,
    silentTranslationWarn: true
})
